module.exports = __webpack_public_path__ + "public/images/performing-arts.ca00d5c0225f531c51770b9836bce0c7.png";